import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, from, fromEvent, interval, merge, Observable, of, Subscription } from 'rxjs';
import { mapTo, switchMap } from 'rxjs/operators';

@Injectable()
export class ConnectionService {
  private onlineStatus = new BehaviorSubject<boolean>(navigator.onLine);
  public status$ = this.onlineStatus.asObservable();

  private pingSubscription?: Subscription;

  constructor(private ngZone: NgZone) {
    this.setupOnlineOfflineEvents();
  }

  private setupOnlineOfflineEvents() {
    const online$ = fromEvent(window, 'online').pipe(mapTo(true));
    const offline$ = fromEvent(window, 'offline').pipe(mapTo(false));

    merge(online$, offline$, of(navigator.onLine)).subscribe((isOnline) => {
      if (!isOnline) this.onlineStatus.next(false);
    });
  }

  private verifyConnection(): Observable<boolean> {
    return from(
      fetch('/assets/ping.json', { method: 'HEAD', cache: 'no-store' })
        .then((res) => res.ok)
        .catch(() => false)
    );
  }

  public startPinging() {
    if (this.pingSubscription) return; // Prevent multiple intervals

    this.pingSubscription = interval(3000)
      .pipe(
        switchMap(() => this.verifyConnection())
      )
      .subscribe((status: boolean) => {
        this.ngZone.run(() => {
          this.onlineStatus.next(status);
        });
      });
  }

  public stopPinging() {
    this.pingSubscription?.unsubscribe();
    this.pingSubscription = undefined;
  }
}
